const img1 = require("../images/slider/slide_1.png").default
const img2 = require("../images/slider/slide_2.png").default
const img3 = require("../images/slider/slide_3.png").default

const heroSliderData = [
    {
        title: "Polo Pima Modal ",
        description: "Essay on Clothes – Some have it in accordance to the latest  set out to be the visionaries in the field, creating and endorsing their own ‘label’. And still, there is yet another category who adorns it attributing to the mood swings they are going through, Clothes have evolved from being a mere covering to the body .",
        img: img1,
        path: "/catalog/ao-thun-dinosaur-01",
        color: "blue"
    },
    {
        title: "Polo season Modal",
        description: "Essay on Clothes – Some have it in accordance to the latest  set out to be the visionaries in the field, creating and endorsing their own ‘label’. And still, there is yet another category who adorns it attributing to the mood swings they are going through, Clothes have evolved from being a mere covering to the body .",        img: img2,
        path: "/catalog/ao-thun-dinosaur-02",
        color: "pink"
    },
    {
        title: "Polo Lacoste Modal",
        description: "Essay on Clothes – Some have it in accordance to the latest  set out to be the visionaries in the field, creating and endorsing their own ‘label’. And still, there is yet another category who adorns it attributing to the mood swings they are going through, Clothes have evolved from being a mere covering to the body .",        img: img3,
        path: "/catalog/ao-thun-dinosaur-03",
        color: "orange"
    }
]

export default heroSliderData